import styled, { css } from 'styled-components';
import { layout, colorUtils, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import DragIndicatorIcon from '../icons/drag-indicator';

import { LIST_DELETE_TRANSITION_TIME } from '../../constants';

import { ItemRow } from '../item-row/styles';

const padding = layout.spacing.xSmall;

export const DragIcon = styled(DragIndicatorIcon)``;

type ListItemProps = {
  draggable: boolean;
  styling: 'background' | 'lines';
  deleting: boolean;
  hasDragHandle?: boolean;
};

export const ListItem = styled.div<ListItemProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  opacity: 1;
  position: relative;
  cursor: pointer;

  margin-bottom: ${p => (p.draggable ? 0 : layout.spacing.xSmall)};

  ${p =>
    p.draggable &&
    css`
      ${media.smallOnly`
        max-width: calc(100% - ${layout.dragAndDropHandleSize.mobile.rem});
      `}
    `};

  ${p =>
    p.styling === 'background' &&
    css`
      border-radius: ${layout.borderRadius};
      background: ${p.theme.bg.secondary};
      transition: background 150ms ease;

      &:hover {
        background: ${colorUtils.shadeColor(p.theme.bg.secondary, -5)};
      }

      ${ItemRow} {
        padding-left: ${p.draggable && !p.hasDragHandle ? 0 : padding};
      }
    `};

  ${p =>
    p.styling === 'lines' &&
    css`
      border-bottom: 1px solid ${p.theme.lines.primary};

      ${DragIcon} {
        position: absolute;
        left: -${padding};
      }

      ${media.mediumDown`
        &:last-child {
          border: ${!p.draggable && 'none'};
        }
      `};
    `};

  ${props =>
    props.deleting &&
    css`
      transition: max-height ${LIST_DELETE_TRANSITION_TIME}ms ease,
        opacity ${LIST_DELETE_TRANSITION_TIME}ms ease;
      opacity: 0;
      max-height: 0;
      overflow: hidden;
    `}

  .list-dropdown {
    .ui-dropdown--header {
      padding: 0;
    }
    .ui-dropdown--list-expanded {
      z-index: 2;
    }
  }
`;

ListItem.defaultProps = {
  styling: 'lines',
};

export const Content = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
`;

export const QuantityControls = styled.div`
  display: flex;

  button {
    width: 25px;
    height: 25px;
  }
`;

export const NotFound = styled.div`
  height: 60px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  font-style: italic;
  color: ${p => p.theme.text.tertiary};
`;

export const LoadMore = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 65px; /* Stops content from jumping when the spinner appears */
`;

export const PlaceholderListItem = styled(ListItem)`
  margin-bottom: ${layout.spacing.xSmall};
  pointer-events: none;
`;

export const LoginButton = styled(Button)`
  display: block;
  margin-left: ${layout.spacing.xSmall};
  margin-right: ${layout.spacing.xSmall};
  &:not(:last-of-type) {
    margin-bottom: ${layout.spacing.xSmall};
  }
`;

export const PromoText = styled.p`
  color: ${({ theme }) => theme.text.tertiary};
  margin: ${layout.spacing.medium} ${layout.spacing.xSmall};
  text-align: center;
`;

type EditControlProps = {
  absolutePositioned: boolean;
};
export const EditControl = styled.div<EditControlProps>`
  margin-right: ${padding};

  ${p =>
    p.absolutePositioned &&
    css`
      margin-right: 0;
      position: absolute;
      top: ${padding};
      right: ${padding};
    `};
`;
